<!-- Vertical Menu -->
@if (menu && layout === 'vertical') {
  @for (item of menu.items; track item.id) {
    <!-- section -->
    @if (item.type == 'section') {
      <li core-menu-vertical-section
          [item]="item"
          class="navigation-header"></li>

      <!-- sub-menu item/collapsible of sections -->
      @for (child of item.children; track child.id) {
        <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
        @if (child.type == 'item') {
          <li core-menu-vertical-item
              [item]="child"
              [ngClass]="{ disabled: child.disabled === true }"
              [routerLinkActive]="!child.openInNewTab ? 'active' : ''"
              [routerLinkActiveOptions]="{ exact: child.exactMatch || false }">
            <span [routerLink]="child.openInNewTab ? [] : [child.url]"
                  class="d-none"></span>
          </li>
        }
        <!-- collapsible -->
        @if (child.type == 'collapsible') {
          <li core-menu-vertical-collapsible
              [item]="child"
              class="nav-item has-sub"></li>
        }
      }
    }

    <!-- item -->
    @if (item.type == 'item') {
      <li core-menu-vertical-item
          [item]="item"
          [ngClass]="{ disabled: item.disabled === true }"
          [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
        <span [routerLink]="item.openInNewTab ? [] : [item.url]"
              class="d-none"></span>
      </li>
    }
    <!-- collapsible -->
    @if (item.type == 'collapsible') {
      <li core-menu-vertical-collapsible
          [item]="item"
          class="nav-item has-sub"></li>
    }
  }

  @if (menu.otherItems?.length) {
    <div class="menu-separator"></div>

    <li class="navigation-header">
      <span class="navigation-section-text">Crm</span>
    </li>
    @for (item of menu.otherItems; track item.id) {
      <!-- section -->
      @if (item.type == 'section') {
        <li core-menu-vertical-section
            [item]="item"
            class="navigation-header"></li>

        <!-- sub-menu item/collapsible of sections -->
        @for (child of item.children; track child.id) {
          <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
          @if (child.type == 'item') {
            <li core-menu-vertical-item
                [item]="child"
                [ngClass]="{ disabled: child.disabled === true }"
                [routerLinkActive]="!child.openInNewTab ? 'active' : ''"
                [routerLinkActiveOptions]="{ exact: child.exactMatch || false }">
              <span [routerLink]="child.openInNewTab ? [] : [child.url]"
                    class="d-none"></span>
            </li>
          }
          <!-- collapsible -->
          @if (child.type == 'collapsible') {
            <li core-menu-vertical-collapsible
                [item]="child"
                class="nav-item has-sub"></li>
          }
        }
      }

      <!-- item -->
      @if (item.type == 'item') {
        <li core-menu-vertical-item
            [item]="item"
            [ngClass]="{ disabled: item.disabled === true }"
            [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
            [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
          <span [routerLink]="item.openInNewTab ? [] : [item.url]"
                class="d-none"></span>
        </li>
      }
      <!-- collapsible -->
      @if (item.type == 'collapsible') {
        <li core-menu-vertical-collapsible
            [item]="item"
            class="nav-item has-sub"></li>
      }
    }
  }
}
<!--/ Vertical Menu -->

<!-- Horizontal Menu -->
@if (layout === 'horizontal') {
  <!-- Legacy: in orizzontale il menu arriva come array; $any per il type-check -->
  @for (item of $any(menu); track $index) {
    <!-- section -->
    @if (item.type == 'section') {
      <li core-menu-horizontal-collapsible
          [item]="item"
          class="dropdown nav-item"></li>
    }

    <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
    @if (item.type == 'item') {
      <li core-menu-horizontal-item
          [item]="item"
          [ngClass]="{ disabled: item.disabled === true }"
          [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
        <span [routerLink]="item.openInNewTab ? [] : [item.url]"
              class="d-none"></span>
      </li>
    }

    <!-- collapsible -->
    @if (item.type == 'collapsible') {
      <li core-menu-horizontal-collapsible
          [item]="item"
          class="dropdown dropdown-submenu"></li>
    }
  }
}
<!--/ Horizontal Menu -->
